import { getCornerstoneRuntime } from './getCornerstoneRuntime';
import { canvasToJpegBlob, JPEG_EXPORT_QUALITY } from './jpegConversion';

export async function captureViewportJpegBlob(
  viewportId: string,
  servicesManager: AppTypes.ServicesManager,
  extensionManager: AppTypes.ExtensionManager
): Promise<Blob> {
  const { cornerstoneViewportService } = servicesManager.services;
  const viewport = cornerstoneViewportService.getCornerstoneViewport(viewportId);

  if (!viewport) {
    throw new Error('Viewport is not available for JPEG export');
  }

  getCornerstoneRuntime(extensionManager);
  viewport.render();

  const canvas = viewport.getCanvas();

  if (!canvas) {
    throw new Error('Viewport canvas is not available');
  }

  return canvasToJpegBlob(canvas, JPEG_EXPORT_QUALITY);
}

export function getCurrentViewportImageIndex(
  viewportId: string,
  servicesManager: AppTypes.ServicesManager
): number {
  const { cornerstoneViewportService } = servicesManager.services;
  const viewport = cornerstoneViewportService.getCornerstoneViewport(viewportId) as {
    getCurrentImageIdIndex?: () => number;
  } | null;

  if (viewport && typeof viewport.getCurrentImageIdIndex === 'function') {
    return viewport.getCurrentImageIdIndex() + 1;
  }

  return 1;
}
